import React, { Component } from "react";
import {Modal, Card, Form, Button, Row, Col, Alert, Tab, Tabs, InputGroup, OverlayTrigger, Tooltip, ListGroup, FormLabel, CardBody} from "react-bootstrap";
import CreatableSelect from 'react-select/creatable';
import { IMaskInput } from "react-imask";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { tiposServicos, formatarValor, formatarValorAPI, categoriasDeProgramas, getCurrentUser, hasPerm, formatarValorLocal} from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import { FaArrowDown, FaArrowUp, FaCheck, FaTimes, FaStream, FaEye, FaSpinner, FaQuestionCircle, FaSearch, FaEdit, FaTrash  } from "react-icons/fa";
import '../ProgramasV2/ProgramasEdit.module.css';
import ReactQuill from 'react-quill';
import ProdutosPrograma from "./ProdutosPrograma";
import EtapasPrograma from "./EtapasPrograma";
import BotoesAtendimento from "./BotoesAtendimento";
import DicasPrograma from "./DicasPrograma";
import GraficosPrograma from "./GraficosPrograma";
import StatusDoPrograma from "./StatusDoPrograma";
import DoencasPrograma from "./DoencasPrograma";
import AcoesPrograma from "./AcoesPrograma";
import ServicosProcedimentos from "./ServicosProcedimentos";
import ColunasAtendimento from "./ColunasAtendimento";
import FiltrosAtendimento from "./FiltrosAtendimento";
import FarmacovigilanciaPrograma from "./FarmacovigilanciaPrograma";
import MonitoriaPrograma from "./MonitoriaPrograma";
import MotivosOptout from "./MotivosOptout";
import ApiKeysPrograma from "./ApiKeysPrograma";

class ProgramasV2Edit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.onChangeWelcomeKit = this.onChangeWelcomeKit.bind(this);
        this.onChangeTermoPacientePDF = this.onChangeTermoPacientePDF.bind(this);
        this.onChangeClienteId = this.onChangeClienteId.bind(this);
        this.onChangeImagem = this.onChangeImagem.bind(this);
        this.onChangeImagemBranca = this.onChangeImagemBranca.bind(this);
        this.onChangeTermo = this.onChangeTermo.bind(this);
        this.onChangeTermoPrestador = this.onChangeTermoPrestador.bind(this);
        this.onChangeGrupo = this.onChangeGrupo.bind(this);
        this.onChangeModeloNovo = this.onChangeModeloNovo.bind(this);
        this.onChangeModeloExistente = this.onChangeModeloExistente.bind(this);

        this.enviaPrograma = this.enviaPrograma.bind(this);

        this.onDragEnd = this.onDragEnd.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            uuid: '', //aaaa
            nome: '',
            descricao: '',
            telefone: "",
            welcome_kit: '',
            welcome_kit_upload: '',
            termo_paciente_pdf: '',
            termo_paciente_pdf_upload: '',
            dados_status: '',
            imagem_upload: '',
            imagem: '',
            magem_branca_upload: '',
            imagem_branca: '',
            optout_logomarca_1: '',
            optout_logomarca_2: '',
            termo_id: '',
            termo_nome: '',
            termo_prestador_id: '',
            termo_prestador_nome: '',
            exige_confirmacao_diagnostico: '',
            validacao_doenca: "paciente",
            showModalTemplate: false,
            cliente_id: "",
            permite_menor_idade: true,
            permite_atendimento_extra_com_aprovacao: true,
            medico_cadastro: false,
            laboratorio_cadastro: false,
            exibir_endereco_medico: false,
            habilitar_agendamentos_servicos: false,
            habilitar_vinculo_atendente: false,
            habilitar_escolha_laboratorio: false,
            habilitar_escolha_multiprofissional: false, 
            habilitar_gestao_aplicacoes: false,
            habilitar_optin_telefone: false,
            habilitar_validacao_atendimento: false,
            habilitar_registro_compras: false,
            habilitar_registro_dosagens: false,
            habilitar_gestao_produtos: false,
            ocultar_menu_atendimentos: false,
            ocultar_menu_receptivos: false,
            ocultar_menu_prestadores: false,
            ocultar_nome_local: false,
            endereco_paciente_obrigatorio: false,
            permite_reativar_atendimento: false,
            optout_habilitado: false,
            layout_cor_fundo: '#FFFFFF',
            layout_cor_primaria: '#000000',
            layout_cor_secundaria: '#333333',
            label_botao_atendimento: '',
            label_endereco_paciente: '',
            canais_contato: '',
            nome_equipe: '',
            orientacao_cadastro: '',
            instrucoes_paciente_termo: '',
            instrucoes2_paciente_termo: '',
            dicas_texto: '',
            instrucao_atendimento: '',
            informacoes_receptivo: '',
            optout_titulo: '',
            optout_texto: '',
            template_atendimento_receptivo: '',
            link_politica_programa: '',
            link_regulamento_programa: '',
            medico_novo_modelo_mensagem_id: '',
            medico_novo_modelo_mensagem_titulo: '',
            medico_existente_modelo_mensagem_id: '',
            medico_existente_modelo_mensagem_titulo: '',
            versao: '',
            dados_cliente: Object,
            categoria: "",
            optout_status_id: "",
            contato_nome: "",
            contato_celular: "",
            contato_email: "",
            status: true,
            grupo_cadastro_medico_id: '',
            grupo_cadastro_medico_nome: '',
            texto_sessao1: '' ,
            n_documento: '' ,
            imagemHelper: "",
            imagemBrancaHelper: "",
            logomarca1Helper: "",
            logomarca2Helper: "",
            nomeHelper: "",
            welcomeKitHelper: "",
            termoPacientePDFHelper: "",
            clienteIdHelper: "",
            categoriaHelper: "",
            optoutHelper: "",
            telefoneHelper: "",
            descricaopHelper: "",
            contatoNomeHelper: "",
            contatoCelularHelper: "",
            contatoEmailHelper: '',
            layoutCorFundoHelper: '',
            layoutCorPrimariaHelper: '',
            layoutCorSecundariaHelper: '',
            statusHelper: '',
            erroLoadRegistro: "",
            programa_id: "",
            titulo_pagina: "",
            loading: false,
            tipo_faturamento: "",
            opcoesClientes: [],
            carregamentoAbas: [],
            status_programa: [],        
            dadosDoencaPrincipal: {
                validacao_doenca: "",
                exige_confirmacao_diagnostico: "",
                label_doencas: "",
                doenca_principal_id: "",
                doenca_principal_nome: ""
            },
            dadosFarmacovigilancia: {
                farmacovigilancia_formulario_id: '',
                farmacovigilancia_formulario_nome: '',
                farmacovigilancia_email: ''
            },
            dadosMonitoriaPrograma: {
                aplicacoes_legenda: ''
            },
            statusProgramaCarregado: false,
            historico_de_compras: [{ valor: '', produto_id: '', produto_nome: '', id: null, focusProduto: false, produtoSearchTimeout: null, focusEtapa: false, etapaSearchTimeout: null }],
            label_doencas: "",
            habilitar_tipos_agendamento: "",
            agendamento_email_solicitacao_prestador: "",
            agendamento_email_atualizacao_status: "",
            limite_atendimentos_por_cpf: "",
            aviso_limite_atendimentos: "",
            template_titulo: "Configuração de templates para envio manual",
            templates: [{ titulo: "", template: "", destinatario: "" }],
            template_id: "",
            tituloHelper: "",
            templateHelper: "",
            destinatarioHelper: "",
        };

        this.tiposFaturamento = {
            "atendimento": "Atendimento",
            "servico": "Serviço"
        };
    }

    componentDidMount(){

        let dados_usuario = getCurrentUser();
        if (!hasPerm('view_programas') || dados_usuario['tipo_usuario'] != '') {
            this.props.router.navigate("/sem-permissao");
            return;
        }

        this.carregarDadosPrograma();
    }

    carregarDadosPrograma = async () => {
        const id = this.props.router.params.id;

        if(id){
            this.setState({
                programa_id: id,
                titulo_pagina: 'Editando Programa',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do programa na api
            await api.get(`/programas/${id}`)
            .then(response => {
                const dadosResponse = response.data;
                const dados = this.tratarNulos(dadosResponse);

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    uuid: dados.uuid,
                    nome: dados.nome,
                    descricao: dados.descricao,
                    telefone: dados.telefone,
                    welcome_kit: dados.welcome_kit,
                    termo_paciente_pdf: dados.termo_paciente_pdf,
                    imagem: dados.imagem,
                    imagem_branca: dados.imagem_branca,
                    optout_logomarca_1: dados.optout_logomarca_1,
                    optout_logomarca_2: dados.optout_logomarca_2,
                    dados_status: dados.dados_status,
                    termo_id: dados.termo_id,
                    termo_nome: (dados.dados_termo.nome) ? dados.dados_termo.nome : '',
                    termo_prestador_id: dados.termo_prestador_id,
                    termo_prestador_nome: (dados.dados_termo_prestador.nome) ? dados.dados_termo_prestador.nome : '',
                    medico_novo_modelo_mensagem_id: dados.medico_novo_modelo_mensagem_id,
                    medico_novo_modelo_mensagem_titulo: dados.dados_medico_novo_modelo_mensagem.titulo,
                    medico_existente_modelo_mensagem_id: dados.medico_existente_modelo_mensagem_id,
                    medico_existente_modelo_mensagem_titulo: dados.dados_medico_existente_modelo_mensagem.titulo,
                    cliente_id: dados.cliente_id,
                    dados_cliente: dados.dados_cliente,
                    categoria: dados.categoria,
                    optout_status_id: dados.optout_status_id,
                    contato_nome: dados.contato_nome,
                    contato_celular: dados.contato_celular,
                    contato_email: dados.contato_email,
                    permite_menor_idade: dados.permite_menor_idade,
                    permite_atendimento_extra_com_aprovacao: dados.permite_atendimento_extra_com_aprovacao,
                    medico_cadastro: dados.medico_cadastro,
                    laboratorio_cadastro: dados.laboratorio_cadastro,
                    habilitar_agendamentos_servicos: dados.habilitar_agendamentos_servicos,
                    habilitar_gestao_produtos: dados.habilitar_gestao_produtos,
                    habilitar_vinculo_atendente: dados.habilitar_vinculo_atendente,
                    habilitar_escolha_laboratorio: dados.habilitar_escolha_laboratorio,
                    habilitar_escolha_multiprofissional: dados.habilitar_escolha_multiprofissional,
                    habilitar_optin_telefone: dados.habilitar_optin_telefone,
                    habilitar_registro_compras: dados.habilitar_registro_compras,
                    habilitar_registro_dosagens: dados.habilitar_registro_dosagens,
                    habilitar_gestao_aplicacoes: dados.habilitar_gestao_aplicacoes,
                    ocultar_menu_atendimentos: dados.ocultar_menu_atendimentos,
                    habilitar_validacao_atendimento: dados.habilitar_validacao_atendimento,
                    ocultar_menu_receptivos: dados.ocultar_menu_receptivos,
                    ocultar_menu_prestadores: dados.ocultar_menu_prestadores,
                    ocultar_nome_local: dados.ocultar_nome_local,
                    endereco_paciente_obrigatorio: dados.endereco_paciente_obrigatorio,
                    permite_reativar_atendimento: dados.permite_reativar_atendimento,
                    optout_habilitado: dados.optout_habilitado,
                    grupo_cadastro_medico_id: dados.grupo_cadastro_medico_id,
                    grupo_cadastro_medico_nome: dados.dados_grupo_cadastro_medico.nome,
                    layout_cor_fundo: dados.layout_cor_fundo,
                    layout_cor_primaria: dados.layout_cor_primaria,
                    layout_cor_secundaria: dados.layout_cor_secundaria,
                    label_botao_atendimento: dados.label_botao_atendimento,
                    label_endereco_paciente: dados.label_endereco_paciente,
                    canais_contato: dados.canais_contato,
                    nome_equipe: dados.nome_equipe,
                    orientacao_cadastro: dados.orientacao_cadastro,
                    instrucoes_paciente_termo: dados.instrucoes_paciente_termo,
                    instrucoes2_paciente_termo: dados.instrucoes2_paciente_termo,
                    dicas_texto: dados.dicas_texto,
                    instrucao_atendimento: dados.instrucao_atendimento,
                    informacoes_receptivo: dados.informacoes_receptivo,
                    optout_titulo: dados.optout_titulo,
                    optout_texto: dados.optout_texto,
                    template_atendimento_receptivo: dados.template_atendimento_receptivo,
                    link_politica_programa: dados.link_politica_programa,
                    link_regulamento_programa: dados.link_regulamento_programa,
                    versao: dados.versao,
                    status: dados.status,
                    tipo_faturamento: dados.tipo_faturamento,

                    //loading: false,
                    opcoesClientes: [{
                        value: dados.cliente_id,
                        label: dados.dados_cliente.nome_fantasia || dados.dados_cliente.nome
                    }],
                    titulo_pagina: 'Editando Programa: ' + dados.nome,
                    habilitar_tipos_agendamento: dados.habilitar_tipos_agendamento,
                    agendamento_email_solicitacao_prestador: dados.agendamento_email_solicitacao_prestador,
                    agendamento_email_atualizacao_status: dados.agendamento_email_atualizacao_status,
                    limite_atendimentos_por_cpf: dados.limite_atendimentos_por_cpf,
                    aviso_limite_atendimentos: dados.aviso_limite_atendimentos,
                    dadosDoencaPrincipal: {
                        validacao_doenca: dados.validacao_doenca,
                        exige_confirmacao_diagnostico: dados.exige_confirmacao_diagnostico,
                        label_doencas: dados.label_doencas,
                        doenca_principal_id: dados.doenca_principal_id,
                        doenca_principal_nome: dados.dados_doenca_principal.nome
                    },
                    dadosFarmacovigilancia: {
                        farmacovigilancia_formulario_id: dados.farmacovigilancia_formulario_id,
                        farmacovigilancia_formulario_nome: dados.dados_farmacovigilancia_formulario.nome,
                        farmacovigilancia_email: dados.farmacovigilancia_email
                    },
                    dadosMonitoriaPrograma: {
                        aplicacoes_legenda: dados.aplicacoes_legenda
                    }

                })

                this.carregarOptOutMotivos();
                
                /*
                this.carregarStatusPrograma();
                this.carregarStatusAplicacao();
                */
                this.setState({
                    loading: false
                })
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar programa, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {

            if(!hasPerm('add_programas')) {
                this.props.router.navigate("/sem-permissao");
                return;
            }

            this.setState({
                programa_id: '',
                titulo_pagina: 'Adicionar Programa',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }


    tratarNulos = (obj) => {
        const novoObjeto = {};
        for (let key in obj) {
            novoObjeto[key] = (obj[key] === null || obj[key] === "null") ? "" : obj[key];
        }
        return novoObjeto;
    };

    
    carregarClientes = async (inputValue) => {
        if(!this.state.focusCliente){
            return [];
        }
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: (cliente.dados_pessoa.nome_fantasia) ? `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})` : `${cliente.dados_pessoa.nome}`
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    carregarTermos = async (inputValue, tipo) => {
        if(tipo === 'prestador') {
            if(!this.state.focusTermoPrestador) {
                return [];
            }
        } else if(tipo === 'paciente') {
            if(!this.state.focusTermoPaciente) {
                return [];
            }
        }
        try {
            const response = await api.get(`/termos/?titulo=${inputValue}`);
            const opcoes = response.data.results.map(termo => ({
                value: termo.id,
                label: termo.titulo
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar termos:', error);
            return [];
        }
    };

    carregarModelosMensagem = async (inputValue, tipo) => {
        if(tipo === 'novo') {
            if(!this.state.focusModeloNovo) {
                return [];
            }
        } else if(tipo === 'existente') {
            if(!this.state.focusModeloExistente) {
                return [];
            }
        }

        try {
            const response = await api.get(`/configuracoes/modelos-mensagem/?titulo=${inputValue}`);
            const opcoes = response.data.results.map(carregarModelosMensagem => ({
                value: carregarModelosMensagem.id,
                label: carregarModelosMensagem.titulo,
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar formulários:', error);
            return [];
        }
    };

    carregarProdutos = async (inputValue, index) => {
        if(!this.state.produtos[index].focusProduto) {
            return [];
        }
        try {
            const response = await api.get(`/produtos/?nome=${inputValue}&status=1`);
            const opcoes = response.data.results.map(produto => ({
                value: produto.id,
                label: produto.nome,
                valor: formatarValor(produto.valor)
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar produtos:', error);
            return [];
        }
    };


    onChangeGrupo = (grupoSelecionado) => {
        this.setState({ grupo_cadastro_medico_id: grupoSelecionado ? grupoSelecionado.value : '', grupo_cadastro_medico_nome: grupoSelecionado ? grupoSelecionado.label : '' });
    };

    carregarGrupos = async (inputValue) => {
        if(!this.state.focusGrupo) {
            return [];
        }
        try {
            const response = await api.get(`/grupos/?busca=${inputValue}`);
            const opcoes = response.data.results.map(grupo => ({
                value: grupo.id,
                label: grupo.name
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar grupos:', error);
            return [];
        }
    };


    enviaMotivoOptOut = async () => {
        const formData = new FormData();
    
        const url = '/programas/optout-motivos/' + this.state.programa_id + '/';
        const metodo = 'put';
    
        if (this.state.titulo) {
            formData.append('titulo', this.state.titulo);
        }
        if (this.state.ordem) {
            formData.append('ordem', this.state.ordem);
        }

        try {
            // Enviar os dados para o backend
            const response = await api({
                method: metodo,
                url: url,
                data: formData,
            });

            // Exibir a mensagem de sucesso
            const MySwal = withReactContent(Swal);
            const textSwal = 'Monitoria atualizado com sucesso';
    
            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });
    
            this.setState({
                loading: false,
            });
        } 
        catch (error) {
            let erro_msg = "Erro ao realizar o cadastro:<br />";
    
            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const responseData = error.response.data;
                const campos = responseData.erros ? responseData.erros : responseData;
                // Adicionar lógica para exibir mensagens de erro específicas, se necessário
            }
    
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção!",
                html: erro_msg,
            });
    
            this.setState({
                loading: false,
            });
        }    
    } 


    excluirTermoPdf = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        const MySwal = withReactContent(Swal)

        MySwal.fire({
            title: '<p>Você tem certeza que deseja excluir o arquivo?</p>',
            text: 'Esta ação não pode ser desfeita.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                if(this.state.programa_id){ 
                    const url = '/programas/'+this.state.programa_id+'/'
                    const metodo = 'put'

                    formData.append('excluir_pdf', true);
                    api({
                        method: metodo,
                        url: url,
                        data: formData,
                    })
                    .then(response => {            
                        MySwal.fire(
                            'Excluído!',
                            'O arquivo foi excluído com sucesso.',
                            'success'
                        );
                        
                        this.setState({
                            loading: false,
                        })
                        this.carregarDadosPrograma();
                        
                    })
                    .catch(error => {
                        let erro_msg = "Erro ao realizar o cadastro:<br />";      
            
                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const responseData = error.response.data;
                            const campos = responseData.erros ? responseData.erros : responseData;                         
                        }

                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: "Atenção!",
                            html: erro_msg,
                        })    
                        
                        this.setState({
                            loading: false,
                        })
                    });

                }
            } else {
                return;
            }
        });
        this.setState({
            termo_paciente_pdf_excluir: true
        });    
    }

    enviaPrograma = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            imagemHelper: "",
            imagemBrancaHelper: "",
            logomarca1Helper: "",
            logomarca2Helper: "",
            nomeHelper: "",
            welcomeKitHelper: "",
            termoPacientePDFHelper: "",
            clienteIdHelper: "",
            categoriaHelper: "",
            optoutHelper: "",
            telefoneHelper: "",
            descricaopHelper: "",
            contatoNomeHelper: "",
            contatoCelularHelper: "",
            contatoEmailHelper: '',
        });

        //vererifica se é edição ou adição
        const url = (this.state.programa_id) ? '/programas/'+this.state.programa_id+'/' : '/programas/'
        const metodo = (this.state.programa_id) ? 'put' : 'post'

        if (this.state.imagem_branca_upload) {
            formData.append('imagem_branca', this.state.imagem_branca_upload);
        }
        if (this.state.imagem_upload) {
            formData.append('imagem', this.state.imagem_upload);
        }
        if (this.state.optout_logomarca_1 instanceof File) {
            formData.append('optout_logomarca_1', this.state.optout_logomarca_1);
        }
        if (this.state.optout_logomarca_2 instanceof File) {
            formData.append('optout_logomarca_2', this.state.optout_logomarca_2);
        }
        if (this.state.welcome_kit_upload) {
            formData.append('welcome_kit', this.state.welcome_kit_upload);
        }
        if (this.state.termo_paciente_pdf_upload) {
            formData.append('termo_paciente_pdf', this.state.termo_paciente_pdf_upload);
        }

        formData.append('nome', this.state.nome);
        formData.append('descricao', this.state.descricao);
        formData.append('telefone', this.state.telefone);
        formData.append('cliente_id', this.state.cliente_id);

        if(this.state.grupo_cadastro_medico_id) {
            formData.append('grupo_cadastro_medico_id', this.state.grupo_cadastro_medico_id);
        }
        
        if(this.state.termo_id) {
            formData.append('termo_id', this.state.termo_id);
        }

        if(this.state.termo_prestador_id) {
            formData.append('termo_prestador_id', this.state.termo_prestador_id);
        }

        if (this.state.template_atendimento_receptivo) {
            formData.append('template_atendimento_receptivo', this.state.template_atendimento_receptivo);
        }

        formData.append('categoria', this.state.categoria);
        formData.append('optout_status_id', this.state.optout_status_id);
        formData.append('contato_nome', this.state.contato_nome);
        formData.append('contato_celular', this.state.contato_celular);
        formData.append('contato_email', this.state.contato_email);
        formData.append('status', this.state.status);
        formData.append('permite_menor_idade', this.state.permite_menor_idade);
        formData.append('permite_atendimento_extra_com_aprovacao', this.state.permite_atendimento_extra_com_aprovacao);    
        formData.append('medico_cadastro', this.state.medico_cadastro);      
        formData.append('laboratorio_cadastro', this.state.laboratorio_cadastro);       
        formData.append('habilitar_agendamentos_servicos', this.state.habilitar_agendamentos_servicos);    
        formData.append('habilitar_gestao_produtos', this.state.habilitar_gestao_produtos);    
        formData.append('habilitar_vinculo_atendente', this.state.habilitar_vinculo_atendente);      
        formData.append('habilitar_escolha_laboratorio', this.state.habilitar_escolha_laboratorio);     
        formData.append('habilitar_escolha_multiprofissional', this.state.habilitar_escolha_multiprofissional);         
        formData.append('habilitar_optin_telefone', this.state.habilitar_optin_telefone);                
        formData.append('habilitar_gestao_aplicacoes', this.state.habilitar_gestao_aplicacoes);         
        formData.append('habilitar_registro_compras', this.state.habilitar_registro_compras);         
        formData.append('habilitar_registro_dosagens', this.state.habilitar_registro_dosagens);               
        formData.append('ocultar_menu_atendimentos', this.state.ocultar_menu_atendimentos);        
        formData.append('habilitar_validacao_atendimento', this.state.habilitar_validacao_atendimento);        
        formData.append('ocultar_menu_receptivos', this.state.ocultar_menu_receptivos);        
        formData.append('ocultar_menu_prestadores', this.state.ocultar_menu_prestadores);        
        formData.append('ocultar_nome_local', this.state.ocultar_nome_local);        
        formData.append('endereco_paciente_obrigatorio', this.state.endereco_paciente_obrigatorio);        
        formData.append('permite_reativar_atendimento', this.state.permite_reativar_atendimento);        
        formData.append('optout_habilitado', this.state.optout_habilitado);        
        formData.append('layout_cor_fundo', this.state.layout_cor_fundo);  
        formData.append('layout_cor_primaria', this.state.layout_cor_primaria);  
        formData.append('layout_cor_secundaria', this.state.layout_cor_secundaria);  
        formData.append('label_botao_atendimento', this.state.label_botao_atendimento);   
        formData.append('label_endereco_paciente', this.state.label_endereco_paciente);    
        formData.append('canais_contato', this.state.canais_contato);    
        formData.append('nome_equipe', this.state.nome_equipe);    
        formData.append('orientacao_cadastro', this.state.orientacao_cadastro);    
        formData.append('instrucoes_paciente_termo', this.state.instrucoes_paciente_termo);    
        formData.append('instrucoes2_paciente_termo', this.state.instrucoes2_paciente_termo);  
        formData.append('dicas_texto', this.state.dicas_texto);            
        formData.append('instrucao_atendimento', this.state.instrucao_atendimento);    
        formData.append('informacoes_receptivo', this.state.informacoes_receptivo);       
        formData.append('optout_titulo', this.state.optout_titulo);       
        formData.append('optout_texto', this.state.optout_texto);       
        formData.append('link_politica_programa', this.state.link_politica_programa);    
        formData.append('link_regulamento_programa', this.state.link_regulamento_programa);  

        formData.append('habilitar_tipos_agendamento ', this.state.habilitar_tipos_agendamento);  
        formData.append('agendamento_email_solicitacao_prestador', this.state.agendamento_email_solicitacao_prestador);  
        formData.append('agendamento_email_atualizacao_status', this.state.agendamento_email_atualizacao_status);  
        formData.append('limite_atendimentos_por_cpf', this.state.limite_atendimentos_por_cpf);  
        formData.append('aviso_limite_atendimentos', this.state.aviso_limite_atendimentos);  


        formData.append('tipo_faturamento', this.state.tipo_faturamento);  

        if(this.state.medico_novo_modelo_mensagem_id) {
            formData.append('medico_novo_modelo_mensagem_id', this.state.medico_novo_modelo_mensagem_id);  
        }
        
        if(this.state.medico_existente_modelo_mensagem_id) {
            formData.append('medico_existente_modelo_mensagem_id ', this.state.medico_existente_modelo_mensagem_id);  
        }
        
        formData.append('versao', this.state.versao);    

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.programa_id) ? 'Programa atualizado com sucesso' : 'Programa cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.programa_id){
                this.props.router.navigate("/programas");
            } else {
                this.carregarDadosPrograma();
            }
        })
        .catch(error => {
            let erro_msg = "Erro ao realizar o cadastro:<br />";      

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const responseData = error.response.data;
                const campos = responseData.erros ? responseData.erros : responseData;                         
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    erro_msg += "<br />" + key + ": " + value;

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'descricao'){
                        this.setState({ descricaopHelper: value })
                    }
                    if(key === 'telefone'){
                        this.setState({ telefoneHelper: value })
                    }
                    if(key === 'imagem'){
                        this.setState({ imagemHelper: value })
                    }
                    if(key === 'imagem_branca'){
                        this.setState({ imagemBrancaHelper: value })
                    }
                    if(key === 'optout_logomarca_1'){
                        this.setState({ logomarca1Helper: value })
                    }
                    if(key === 'optout_logomarca_2'){
                        this.setState({ logomarca2Helper: value })
                    }
                    if(key === 'welcome_kit'){
                        this.setState({ welcomeKitHelper: value })
                    }
                    if(key === 'termo_paciente_pdf'){
                        this.setState({ termoPacientePDFHelper: value })
                    }
                    if(key === 'cliente_id'){
                        this.setState({ clienteIdHelper: value })
                    }
                    if(key === 'termo_id'){
                        this.setState({ termoIdHelper: value })
                    }
                    if(key === 'categoria'){
                        this.setState({ categoriaHelper: value })
                    }
                    if(key === 'optout_status_id'){
                        this.setState({ optoutHelper: value })
                    }
                    if(key === 'contato_nome'){
                        this.setState({ contatoNomeHelper: value })
                    }
                    if(key === 'contato_celular'){
                        this.setState({ contatoCelularHelper: value })
                    }
                    if(key === 'contato_email'){
                        this.setState({ contatoEmailHelper: value })
                    }
                    if(key === 'status'){
                        this.setState({ statusHelper: value })
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção!",
                html: erro_msg,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };


    carregarOptOutMotivos = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/optout-motivos/?programa_id=${this.state.programa_id}`)
            .then(response => {
                const optoutCarregado = response.data.map(optout => ({
                    id: optout.id,
                    titulo: optout.titulo,
                    ordem: optout.ordem
                }));
                this.setState({ motivos_optout: optoutCarregado });
            })
            .catch(error => {
                console.error('Erro ao carregar optout:', error);
                
                let erro_msg = 'Erro ao carregar optout da aplicação, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    }

    salvarOptOutPrograma = (index) => {
        const optout = this.state.motivos_optout[index];
        const url = optout.id ? `/programas/optout-motivos/${optout.id}/` : '/programas/optout-motivos/';
        const metodo = optout.id ? 'put' : 'post';
    
        const dadosOptOut = {
            titulo: optout.titulo,
            ordem: optout.ordem,
            programa_id: this.state.programa_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosOptOut,
        })
        .then(response => {
            // Se for um novo botao, atualize o estado com a ID retornada pela API
            if (!optout.id) {
                this.setState(prevState => {
                    const optOutAtualizados = [...prevState.motivos_optout];
                    optOutAtualizados[index].id = response.data.id;
                    return { motivos_optout: optOutAtualizados };
                });
            }
            
            const MySwal = withReactContent(Swal)
            const textSwal = (optout.id) ? 'Optout do programa atualizado com sucesso' : 'Optout do programa cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar optout, verifique os campos e tente novamente'; 
            let content = '';           

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'titulo') {
                        content += `<br>&bull; Titulo: ${value}`;
                    }
                    if(key == 'ordem') {
                        content += `<br>&bull; Ordem: ${value}`;
                    }
                    if(key == 'programa_id') {
                        content += `<br>&bull; Id do Programa: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
        
    }


    adicionarOptOut = () => {
        this.setState(prevState => ({
            motivos_optout: [...prevState.motivos_optout, {titulo: "", ordem: ''}],
        }));
    };

    removerOptOutPrograma = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover optout do programa?',
            text: "Tem certeza que deseja remover este optout do programa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const optout = this.state.motivos_optout[index];

                if (optout.id) {
                    api({
                        method: 'delete',
                        url: `/programas/optout-motivos/${optout.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Optout do programa removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            motivos_optout: prevState.motivos_optout.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o optout, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        motivos_optout: prevState.motivos_optout.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O optout do programa foi removido.',
                        'success'
                    );
                }
            }
        });
    };
    
    handleError = (error, defaultMessage) => {
        let erro_msg = defaultMessage;
        let content = '';
    
        if (error.response && error.response.status === 500) {
            erro_msg = 'Servidor indisponível no momento';
        } else if (error.response && error.response.status === 400) {
            const campos = error.response.data;
            for (let key in campos) {
                const value = campos[key];
                content += `<br>&bull; ${key}: ${value}`;
            }
        }
    
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            icon: 'error',
            showCloseButton: true,
            title: <p>{erro_msg}</p>,
            html: content,
        });
    
        this.setState({ loading: false });
    };

    handleChangeOptOut = (index, event, fieldName) => {
        const motivos_optout = [...this.state.motivos_optout];
        motivos_optout[index] = { ...motivos_optout[index], [fieldName]: event.target.value };
        this.setState({ motivos_optout });
    };

    //TRATAMENTO GERAL
    handleChange = (e) => {
        const { name, value } = e.target;
        if(name == "servico_valor"){
            const valorFormatado = formatarValor(value);
            this.setState({ [name]: valorFormatado });
        } else {
            this.setState({ [name]: value });
        }
    };

    handleChangeTemplate = (index, event) => {
        const { name, value } = event.target;
        this.setState((prevState) => {
            const templates = [...prevState.templates];
            templates[index][name] = value;
            return { templates };
        });
    };

    //TRATAMENTO GERAL
    onChangeClienteId = (clienteSelecionado) => {
        this.setState({ cliente_id: clienteSelecionado ? clienteSelecionado.value : '' });
    };

    onChangeTermo = (termoSelecionado) => {
        this.setState({ termo_id: termoSelecionado ? termoSelecionado.value : '', termo_nome: termoSelecionado ? termoSelecionado.label : '' });
    };

    onChangeTermoPrestador = (termoSelecionado) => {
        this.setState({ termo_prestador_id: termoSelecionado ? termoSelecionado.value : '', termo_prestador_nome: termoSelecionado ? termoSelecionado.label : '' });
    };

    onChangeModeloNovo = (modeloSelecionado) => {
        this.setState({ medico_novo_modelo_mensagem_id: modeloSelecionado ? modeloSelecionado.value : '', medico_novo_modelo_mensagem_titulo: modeloSelecionado ? modeloSelecionado.label : '' });
    };

    onChangeModeloExistente = (modeloSelecionado) => {
        this.setState({ medico_existente_modelo_mensagem_id: modeloSelecionado ? modeloSelecionado.value : '', medico_existente_modelo_mensagem_titulo: modeloSelecionado ? modeloSelecionado.label : '' });
    };

    onChangeImagem = (e) => {
        this.setState({ imagem_upload: e.target.files[0] });
    };

    onChangeImagemBranca = (e) => {
        this.setState({ imagem_branca_upload: e.target.files[0] });
    };

    onChangeLogomarca1 = (e) => {
        this.setState({ optout_logomarca_1: e.target.files[0] });
    };

    onChangeLogomarca2 = (e) => {
        this.setState({ optout_logomarca_2: e.target.files[0] });
    };

    onChangeWelcomeKit = (e) => {
        this.setState({ welcome_kit_upload: e.target.files[0] });
    };

    onChangeTermoPacientePDF = (e) => {
        this.setState({ termo_paciente_pdf_upload: e.target.files[0] });
    };

    //Drag and Drop
    onDragEnd = (result) => {
        const { destination, source } = result;
    
        // Se o destino não existir ou se o item for solto na mesma posição, não faz nada
        if (!destination || (destination.droppableId === source.droppableId && destination.index === source.index)) {
            return;
        }
    
        const newEtapas = Array.from(this.state.etapas);
        const [relocatedItem] = newEtapas.splice(source.index, 1);
        newEtapas.splice(destination.index, 0, relocatedItem);
    
        this.setState({ etapas: newEtapas });
    };

    buscaPesquisas = async () => {
        const opcoes = await pesquisas.map(pesquisa => ({
            value: pesquisa.id,
            label: `[${pesquisa.tipo}] ${pesquisa.nome}`,
        }));
        return opcoes;
    };

    handleStatusChange = (novoStatus) => {
        this.setState({ status_programa: novoStatus }, () => {
            this.setState({ statusProgramaCarregado: true });
        });
    };

    handleSelectTab = async (aba) => {
        if (this.state.carregamentoAbas.length > 0) {
            const containsAba = this.state.carregamentoAbas.some(item => item.nome === aba);
            if(containsAba){
                return;
            }
        }

        this.setState({
            loading: true
        });
        
        try {
            // Executa as requisições de forma assíncrona
            switch (aba) {
                case "servicosDoPrograma":
                    this.setState({
                        carregaServicosPrograma: true
                    });
                    break;
    
                case "etapasDoPrograma":
                    await this.handleSelectTab("statusDoPrograma");
                    this.setState({
                        carregaEtapasPrograma: true
                    });
                    break;
    
                case "produtosDoPrograma":
                    this.setState({
                        carregaProdutosPrograma: true
                    });
                    break;
    
                case "botoesDoPrograma":
                    this.setState({
                        carregaBotoesAtendimento: true
                    });
                    break;
    
                case "dicasDoPrograma":
                    this.setState({
                        carregaDicasPrograma: true
                    });
                    break;
    
                case "GraficosPrograma":
                    this.setState({
                        carregaGraficosPrograma: true
                    });
                    break;
                case "testeDoPrograma":
                    this.setState({
                        carregaTestePrograma: true
                    });
                    break;
                case "statusDoPrograma":
                    this.setState({
                        carregaStatusPrograma: true
                    });
                    break;
                case "doencasDoPrograma":
                    this.setState({
                        carregaDoencasPrograma: true
                    });
                    break;
                case "FarmacovigilanciaPrograma":
                    this.setState({
                        carregaFarmacovigilanciaPrograma: true
                    });
                    break;

                case "monitoriaDoPrograma":
                    this.setState({
                        carregaMonitoriaPrograma: true
                    });
                    break;

                case "MotivosOptoutPrograma":
                    this.setState({
                        carregaMotivosOptoutPrograma: true
                    });
                    break;

                case "AcoesPrograma":
                    this.setState({
                        carregaAcoesPrograma: true
                    });
                    break;

                case "apiKeysPrograma":
                    this.setState({
                        carregaApiKeysPrograma: true
                    });
                    break;
                
                case "colunasDoPrograma":
                    this.setState({
                        carregaColunasAtendimentoPrograma: true
                    });
                    break;

                case "filtrosDoPrograma":
                    this.setState({
                        carregaFiltrosAtendimentoPrograma: true
                    });
                    break;

                default:
                    break;
            }
    
            // Após todas as funções terminarem com sucesso, define loading como false
            this.setState({
                loading: false
            });

            this.setState(prevState => ({
                ...prevState,
                carregamentoAbas: [
                    ...prevState.carregamentoAbas,  // espalha os itens existentes
                    { nome: aba, status: true }     // adiciona o novo item ao final
                ]
            }));
    
        } catch (error) {
            // Caso algum erro aconteça, define loading como false
            console.error("Erro ao carregar os dados:", error);
            this.setState({
                loading: false
            });
        }
    }

    carregarTemplatesWhatsapp = () => {
        const { etapaSelecionada } = this.state;
        if (!etapaSelecionada || !etapaSelecionada.id) {
            console.error("Erro: Nenhuma etapa selecionada.");
            return;
        }
    
        api.get(`/programas/etapas/templates-whatsapp/?etapa_id=${etapaSelecionada.id}`)
            .then(response => {
                const templatesCarregados = response.data.results.map(template => ({
                    id: template.id,
                    etapa_id: template.etapa_id,
                    titulo: template.titulo,
                    template: template.template,
                    destinatario: template.destinatario,
                }));
    
                this.setState({
                    templates: templatesCarregados,
                    erroLoadRegistro: '',
                    showModalTemplate: true, 
                    loading: false,
                });
            })
            .catch(error => {
                let erro_msg = "Erro ao carregar templates, tente novamente";
    
                if (error.response && error.response.status === 500) {
                    erro_msg = "Servidor indisponível no momento, tente novamente";
                }
    
                this.setState({
                    erroLoadRegistro: erro_msg,
                    loading: false,
                });
            });
    };
    
    enviaTemplate = (index, event) => {
        event.preventDefault();
        
        const { etapaSelecionada, templates } = this.state;
    
        if (!etapaSelecionada || !etapaSelecionada.id) {
            console.error("Erro: Nenhuma etapa selecionada.");
            return;
        }
    
        const formData = new FormData();
        this.setState({
            loading: true,
            templateHelper: "",
            tituloHelper: "",
            destinatarioHelper: "",
        });

        const templateAtual = templates[index];
    
        const url = templateAtual.id
            ? `/programas/etapas/templates-whatsapp/${templateAtual.id}/`
            : "/programas/etapas/templates-whatsapp/";
    
        const metodo = templateAtual.id ? "put" : "post";
    
        formData.append("etapa_id", etapaSelecionada.id);
        formData.append("titulo", templateAtual.titulo);
        formData.append("template", templateAtual.template);
        formData.append("destinatario", templateAtual.destinatario);
    
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            withReactContent(Swal).fire({
                title: <p>Template Whatsapp cadastrado com sucesso</p>,
                icon: "success",
                showCloseButton: true,
            });
    
            this.setState({ loading: false });
    
            this.setState(prevState => ({
                ...prevState,
                carregamentoAbas: [
                    ...prevState.carregamentoAbas,
                    { nome: "etapasDoPrograma", status: false }
                ]
            }));
    
            this.handleSelectTab("etapasDoPrograma");
        })
        .catch(error => {
            let erro_msg = "Erro ao cadastrar o Template Whatsapp, verifique os campos e tente novamente";
    
            if (error.response) {
                if (error.response.status === 500) {
                    erro_msg = "Servidor indisponível no momento";
                } else if (error.response.status === 400) {
                    const campos = error.response.data;
                    
                    this.setState(prevState => {
                        const novosTemplates = [...prevState.templates];
                        novosTemplates[index] = {
                            ...novosTemplates[index],
                            templateHelper: campos.template || "",
                            destinatarioHelper: campos.destinatario || "",
                            tituloHelper: campos.titulo || "",
                        };
                        return { templates: novosTemplates };
                    });
                }
            }
    
            withReactContent(Swal).fire({
                icon: "error",
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            });
    
            this.setState({ loading: false });
        });
    };
    carregarProdutosCompras = async (inputValue, index) => {
        if(!this.state.historico_de_compras[index].focusProduto) {
            return [];
        }
        const programa_id = this.state.programa_id;
        if (programa_id) {
            try {
                const response = await api.get(`/programas/produtos/?programa=${programa_id}&produto=${inputValue}`);
                const opcoesFiltradas = response.data.results.map(produto => ({
                    value: produto.produto_id,
                    label: produto.dados_produto.nome,
                }));

                return opcoesFiltradas;
            } catch (error) {
                console.error('Erro ao carregar campos:', error);
                Sentry.captureException('Erro ao carregar campos:', error);
            }
        }
    };


    excluirTemplate = (index) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover Template?',
            text: "Tem certeza que deseja remover este Template?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const template = this.state.templates[index];

                if (template.id) {

                    const url = `/programas/etapas/templates-whatsapp/${template.id}/`;
                    const metodo = 'delete';
                
                    const dadosTemplate = {
                        status: false
                    };
                
                    api({
                        method: metodo,
                        url: url,
                        data: dadosTemplate,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Template Whatsapp removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            templates: prevState.templates.filter((_, i) => i !== index),
                        }));
                        
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o template, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        templates: prevState.templates.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O Template foi removida.',
                        'success'
                    );
                }
            }
        });
    };

    abrirModalTemplates = (etapa) => {
        this.setState(
            { showModalTemplate: true, etapaSelecionada: etapa, templatesWhatsapp: [] }, 
            () => this.carregarTemplatesWhatsapp(etapa.id)
        );
    };

    adicionarTemplate = () => {
        this.setState(prevState => ({
            templates: [
                ...prevState.templates,
                { titulo: "", template: "", destinatario: "" } // Novo template vazio
            ]
        }));
    };
    
    render(){

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosDoPrograma" id="tabs-programa" className="aditus-tabs" onSelect={this.handleSelectTab}>
                    <Tab eventKey="dadosDoPrograma" title="Dados do Programa">
                        {!this.state.loading  ? (
                        <Form onSubmit={this.enviaPrograma}>
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <h4>Dados Gerais </h4>
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome do Programa <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control type="text" name="nome" required placeholder="Nome do Programa" value={this.state.nome} onChange={this.handleChange} />
                                                <Form.Text id="formNomeHelpBlock" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Cliente</Form.Label>
                                                <AsyncSelect
                                                    key={this.state.focusCliente}
                                                    loadOptions={(inputValue) => {
                                                        return new Promise((resolve) => {
                                                            clearTimeout(this.clienteSearchTimeout);
                                                            this.clienteSearchTimeout = setTimeout(() => {
                                                                resolve(this.carregarClientes(inputValue));
                                                            }, 700);
                                                        });
                                                    }}
                                                    onFocus={() => {
                                                        this.setState({
                                                            focusCliente: true
                                                        });
                                                    }}
                                                    autoFocus={this.state.focusCliente}
                                                    openMenuOnFocus={this.state.focusCliente}
                                                    defaultOptions
                                                    name="cliente_id"
                                                    onChange={this.onChangeClienteId}
                                                    placeholder="Buscar cliente..."
                                                    noOptionsMessage={() => "Nenhum cliente encontrado"}
                                                    value={this.state.opcoesClientes.find(opcao => opcao.value === this.state.cliente_id)}
                                                />
                                                <Form.Text className="text-danger">{this.state.clienteIdHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Categoria<span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control as="select" name="categoria" value={this.state.categoria} required onChange={this.handleChange}>
                                                    <option value="">Categoria do Programa</option>
                                                    {Object.entries(categoriasDeProgramas).map(([sigla, nome]) => (
                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text id="formCategoriaHelpBlock" className="text-danger">{this.state.categoriaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Grupo de Cadastro Médico</Form.Label>
                                                <AsyncSelect
                                                    key={this.state.focusGrupo}
                                                    loadOptions={(inputValue) => {
                                                        return new Promise((resolve) => {
                                                            clearTimeout(this.grupoSearchTimeout);
                                                            this.grupoSearchTimeout = setTimeout(() => {
                                                                resolve(this.carregarGrupos(inputValue));
                                                            }, 700);
                                                        });
                                                    }}
                                                    onFocus={() => {
                                                        this.setState({
                                                            focusGrupo: true
                                                        });
                                                    }}
                                                    autoFocus={this.state.focusGrupo}
                                                    openMenuOnFocus={this.state.focusGrupo}
                                                    defaultOptions
                                                    name="grupo_cadastro_medico_id"
                                                    placeholder="Buscar grupo..."
                                                    noOptionsMessage={() => "Nenhum grupo encontrado"}
                                                    onChange={this.onChangeGrupo}
                                                    value={this.state.grupo_cadastro_medico_id ? { value: this.state.grupo_cadastro_medico_id, label: this.state.grupo_cadastro_medico_nome } : null}
                                                />
                                                <Form.Text className="text-danger">{this.state.grupoIdHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={2} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Tipo de Faturamento </Form.Label>
                                                <Form.Control as="select" name="tipo_faturamento" value={this.state.tipo_faturamento} onChange={this.handleChange}>
                                                    <option value="">Selecione</option>
                                                    {Object.entries(this.tiposFaturamento).map(([value, label]) => (
                                                        <option key={value} value={value}>{label}</option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={2} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Welcome Kit</Form.Label>
                                                <Form.Control type="file" name="welcome_kit_upload" onChange={this.onChangeWelcomeKit} ref={this.fileInput} />
                                                <Form.Text id="formWelcomeKitHelpBlock" className="text-danger">{this.state.welcomeKitHelper}</Form.Text>
                                                {this.state.welcome_kit && (
                                                    <Button variant="light" className="btn-sm" href={this.state.welcome_kit} target="_blank" style={{ marginTop: '10px' }}>
                                                        <FaEye /> Ver Welcome Kit Atual
                                                    </Button>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Descrição do Programa <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    required 
                                                    placeholder="Descrição" 
                                                    name="descricao"
                                                    value={this.state.descricao} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                                <Form.Text id="formDescricaoHelpBlock" className="text-danger">
                                                    {this.state.descricaoHelper}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Row>
                                        <h4>Dados de Contato</h4>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome do Contato</Form.Label>
                                                <Form.Control type="text" name="contato_nome" placeholder="Nome do contato" value={this.state.contato_nome} onChange={this.handleChange} />
                                                <Form.Text id="formContatoNomeHelpBlock" className="text-danger">{this.state.contatoNomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>E-mail</Form.Label>
                                                <Form.Control type="email" placeholder="E-mail" name="contato_email" id="formEmail" value={this.state.contato_email} onChange={this.handleChange} />                            
                                                <Form.Text id="formContatoEmailHelpBlock" className="text-danger">{this.state.contatoEmailHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Celular</Form.Label>
                                                <Form.Control as={IMaskInput} mask="(00) 00000-0000" placeholder="Celular" name="contato_celular" id="formTelefone" value={this.state.contato_celular} onChange={this.handleChange} />
                                                <Form.Text id="formContatoCelularHelpBlock" className="text-danger">{this.state.contatoCelularHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Row>
                                        <h4>Termos do Programa</h4>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Termo PDF para Paciente</Form.Label>
                                                {!this.state.termo_paciente_pdf ? (
                                                    <>
                                                        <Form.Control type="file" name="termo_paciente_pdf" onChange={this.onChangeTermoPacientePDF} ref={this.fileInput} />
                                                        <Form.Text id="formtermoPacientePDFHelpBlock" className="text-danger">{this.state.termoPacientePDFHelper}</Form.Text>
                                                    </>
                                                ) : (
                                                <>
                                                    <br/>
                                                    <Button variant="light" className="btn-sm" onClick={this.excluirTermoPdf} target="_blank" style={{ marginTop: '10px' }}>
                                                        <FaTrash /> Excluir PDF Atual
                                                    </Button>
                                                    <Button variant="light" className="btn-sm" href={this.state.termo_paciente_pdf} target="_blank" style={{ marginTop: '10px' }}>
                                                        <FaEye /> Ver Termo Atual
                                                    </Button>
                                                </>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Versão do Termo PDF</Form.Label>
                                                <Form.Control type="text" name="versao" value={this.state.versao} onChange={this.handleChange} />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Termo para Paciente (Texto)</Form.Label>
                                                <AsyncSelect
                                                    key={this.state.focusTermoPaciente}
                                                    loadOptions={(inputValue) => {
                                                        return new Promise((resolve) => {
                                                            clearTimeout(this.termoSearchTimeout);
                                                            this.termoSearchTimeout = setTimeout(() => {
                                                                resolve(this.carregarTermos(inputValue, 'paciente'));
                                                            }, 700);
                                                        });
                                                    }}
                                                    onFocus={() => {
                                                        this.setState({
                                                            focusTermoPaciente: true
                                                        });
                                                    }}
                                                    autoFocus={this.state.focusTermoPaciente}
                                                    openMenuOnFocus={this.state.focusTermoPaciente}
                                                    defaultOptions
                                                    name="termo_id"
                                                    placeholder="Buscar termo..."
                                                    noOptionsMessage={() => "Nenhum termo encontrado"}
                                                    onChange={this.onChangeTermo}
                                                    value={this.state.termo_id ? { value: this.state.termo_id, label: this.state.termo_nome } : null}
                                                />
                                                <Form.Text className="text-danger">{this.state.termoIdHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Termo para Médicos</Form.Label>
                                                <AsyncSelect
                                                    key={this.state.focusTermoPrestador}
                                                    loadOptions={(inputValue) => {
                                                        return new Promise((resolve) => {
                                                            clearTimeout(this.termoPrestadorSearchTimeout);
                                                            this.termoPrestadorSearchTimeout = setTimeout(() => {
                                                                resolve(this.carregarTermos(inputValue, 'prestador'));
                                                            }, 700);
                                                        });
                                                    }}
                                                    onFocus={() => {
                                                        this.setState({
                                                            focusTermoPrestador: true
                                                        });
                                                    }}
                                                    autoFocus={this.state.focusTermoPrestador}
                                                    openMenuOnFocus={this.state.focusTermoPrestador}
                                                    defaultOptions
                                                    name="termo_prestador_id"
                                                    placeholder="Buscar termo..."
                                                    noOptionsMessage={() => "Nenhum termo encontrado"}
                                                    onChange={this.onChangeTermoPrestador}
                                                    value={this.state.termo_prestador_id ? { value: this.state.termo_prestador_id, label: this.state.termo_prestador_nome } : null}
                                                />
                                                <Form.Text className="text-danger">{this.state.termoIdHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Row>
                                        <h4>Validações</h4>                                
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Permite Menor de Idade?</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.permite_menor_idade ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ permite_menor_idade: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.permite_menor_idade ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ permite_menor_idade: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Permite atendimento extra com aprovacao?</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.permite_atendimento_extra_com_aprovacao ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ permite_atendimento_extra_com_aprovacao: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.permite_atendimento_extra_com_aprovacao ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ permite_atendimento_extra_com_aprovacao: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Exige vinculação de médico?</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.medico_cadastro ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ medico_cadastro: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.medico_cadastro ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ medico_cadastro: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Exige vinculação de laboratório?</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.laboratorio_cadastro ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ laboratorio_cadastro: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.laboratorio_cadastro ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ laboratorio_cadastro: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Vínculo de Atendente/Navegador</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_vinculo_atendente ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_vinculo_atendente: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_vinculo_atendente ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_vinculo_atendente: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Seleção de Laboratório</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_escolha_laboratorio ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_escolha_laboratorio: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_escolha_laboratorio ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_escolha_laboratorio: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Escolha do Multiprofissional</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_escolha_multiprofissional ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_escolha_multiprofissional: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_escolha_multiprofissional ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_escolha_multiprofissional: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Optin por Telefone</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_optin_telefone ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_optin_telefone: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_optin_telefone ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_optin_telefone: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Gestão de Produtos</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_gestao_produtos ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_gestao_produtos: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_gestao_produtos ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_gestao_produtos: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Gestão de Aplicações</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_gestao_aplicacoes ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_gestao_aplicacoes: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_gestao_aplicacoes ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_gestao_aplicacoes: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Registro de Compras</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_registro_compras ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_registro_compras: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_registro_compras ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_registro_compras: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Registro de Dosagens</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_registro_dosagens ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_registro_dosagens: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_registro_dosagens ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_registro_dosagens: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ocultar Menu Atendimentos</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.ocultar_menu_atendimentos ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_menu_atendimentos: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.ocultar_menu_atendimentos ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_menu_atendimentos: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Validacao de Atendimento</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_validacao_atendimento ? "success" : "outline-secondary"}
                                                            onClick={() => this.setState({ habilitar_validacao_atendimento: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_validacao_atendimento ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_validacao_atendimento: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ocultar Menu Receptivos</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.ocultar_menu_receptivos ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_menu_receptivos: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.ocultar_menu_receptivos ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_menu_receptivos: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ocultar Menu Prestadores</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.ocultar_menu_prestadores ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_menu_prestadores : true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.ocultar_menu_prestadores ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_menu_prestadores: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Ocultar Nome Local e Telefone Contato (Endereço paciente)</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.ocultar_nome_local ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_nome_local : true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.ocultar_nome_local ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ ocultar_nome_local: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Exige endereço do paciente</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.endereco_paciente_obrigatorio ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ endereco_paciente_obrigatorio : true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.endereco_paciente_obrigatorio ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ endereco_paciente_obrigatorio: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                            
                                        <Col sm={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Aviso de limite de Atendimentos</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    required 
                                                    placeholder="Descrição" 
                                                    name="aviso_limite_atendimentos"
                                                    value={this.state.aviso_limite_atendimentos} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                            </Form.Group>
                                        </Col>    
                                        <Col sm={2}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Limite de atendimentos por CPF</Form.Label>
                                                <Form.Control 
                                                    type="number" 
                                                    name="limite_atendimentos_por_cpf" 
                                                    value={this.state.limite_atendimentos_por_cpf} 
                                                    onChange={this.handleChange}
                                                />
                                            </Form.Group>
                                        </Col> 
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Permite reativar atendimento</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.permite_reativar_atendimento ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ permite_reativar_atendimento: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.permite_reativar_atendimento ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ permite_reativar_atendimento: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                                
                                </Card.Body>
                            </Card>
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Row>
                                        <h4>Agendamentos</h4>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Agendamento de Serviços</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_agendamentos_servicos ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_agendamentos_servicos: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_agendamentos_servicos ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_agendamentos_servicos: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Tipos de Agendamento</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.habilitar_tipos_agendamento  ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_tipos_agendamento : true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.habilitar_tipos_agendamento  ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ habilitar_tipos_agendamento : false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Conteúdo do E-mail de Solicitação do Prestador</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    placeholder="Descrição" 
                                                    name="agendamento_email_solicitacao_prestador"
                                                    value={this.state.agendamento_email_solicitacao_prestador} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Conteúdo do E-mail de Atualização do Status
                                                </Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    placeholder="Descrição" 
                                                    name="agendamento_email_atualizacao_status"
                                                    value={this.state.agendamento_email_atualizacao_status} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                        {/*
                                            <Form.Group className="mb-3">
                                                <Form.Label>Logomarca <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control type="file" name="imagem_upload" onChange={this.onChangeImagem} ref={this.fileInput} />
                                                <Form.Text id="formImagemHelpBlock" className="text-danger">{this.state.imagemHelper}</Form.Text>
                                                {this.state.imagem && (
                                                    <div>
                                                        <img src={this.state.imagem} alt="Imagem Atual" style={{ maxWidth: '100px', marginTop: '10px' }} />
                                                    </div>
                                                )}
                                            </Form.Group>
                                            */}
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Row>
                                        <h4>Identidade Visual - Layout e Labels</h4>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Logomarca <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control type="file" name="imagem_upload" onChange={this.onChangeImagem} ref={this.fileInput} />
                                                <Form.Text id="formImagemHelpBlock" className="text-danger">{this.state.imagemHelper}</Form.Text>
                                                {this.state.imagem && (
                                                    <div>
                                                        <img src={this.state.imagem} alt="Imagem Atual" style={{ maxWidth: '100px', marginTop: '10px' }} />
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Logomarca Branca</Form.Label>
                                                <Form.Control type="file" name="imagem_branca_upload" onChange={this.onChangeImagemBranca} ref={this.fileInput} />
                                                <Form.Text id="formImagemBrancaHelpBlock" className="text-danger">{this.state.imagemBrancaHelper}</Form.Text>
                                                {this.state.imagem_branca && (
                                                    <div>
                                                        <img src={this.state.imagem_branca} alt="Imagem Branca" style={{ maxWidth: '100px', marginTop: '10px', backgroundColor: '#333' }} />
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor="colorInputFundo">Cor de fundo</Form.Label>                                                
                                                <InputGroup className="mb-3">
                                                    <Form.Control type="text" placeholder="Selecione a cor ao lado" name="layout_cor_fundo" id="formLayoutCorFundo" value={this.state.layout_cor_fundo} onChange={this.handleChange} style={{width: '80%'}} />
                                                    <Form.Control
                                                        type="color"
                                                        id="colorInputFundo"
                                                        name="layout_cor_fundo"
                                                        value={this.state.layout_cor_fundo}
                                                        title="Escolha sua cor"
                                                        onChange={this.handleChange}
                                                        style={{padding: 5, height: 45}}
                                                    />
                                                </InputGroup>
                                                <Form.Text id="layoutCorFundoHelper" className="text-danger">{this.state.layoutCorFundoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor="colorInputFundo">Cor primária</Form.Label>                                                
                                                <InputGroup className="mb-3">
                                                    <Form.Control type="text" placeholder="Selecione a cor ao lado" name="layout_cor_primaria" id="formLayoutCorPrimaria" value={this.state.layout_cor_primaria} onChange={this.handleChange} style={{width: '80%'}} />
                                                    <Form.Control
                                                        type="color"
                                                        id="colorInputPrimaria"
                                                        name="layout_cor_primaria"
                                                        value={this.state.layout_cor_primaria}
                                                        title="Escolha sua cor"
                                                        onChange={this.handleChange}
                                                        style={{padding: 5, height: 45}}
                                                    />
                                                </InputGroup>
                                                <Form.Text id="layoutCorPrimariaHelper" className="text-danger">{this.state.layoutCorPrimariaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label htmlFor="colorInputSecundaria">Cor secundária</Form.Label>                                                
                                                <InputGroup className="mb-3">
                                                    <Form.Control type="text" placeholder="Selecione a cor ao lado" name="layout_cor_secundaria" id="formLayoutCorSecundaria" value={this.state.layout_cor_secundaria} onChange={this.handleChange} style={{width: '80%'}} />
                                                    <Form.Control
                                                        type="color"
                                                        id="colorInputSecundaria"
                                                        name="layout_cor_secundaria"
                                                        value={this.state.layout_cor_secundaria}
                                                        title="Escolha sua cor"
                                                        onChange={this.handleChange}
                                                        style={{padding: 5, height: 45}}
                                                    />
                                                </InputGroup>
                                                <Form.Text id="formContatoNomeHelpBlock" className="text-danger">{this.state.layoutCorSecundariaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>     
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Label endereço paciente <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control type="text" name="label_endereco_paciente" required placeholder="Label endereço paciente" value={this.state.label_endereco_paciente} onChange={this.handleChange} />
                                            </Form.Group>
                                        </Col>   
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Label do Botão Iniciar Atendimento <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control type="text" name="label_botao_atendimento" required placeholder="Label Botão de Atendimento" value={this.state.label_botao_atendimento} onChange={this.handleChange} />
                                                <Form.Text id="formLabelBotaoHelpBlock" className="text-danger">{this.state.labelBotaoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Row>
                                        <h4 className="mt-3">Dados para Mensageria</h4>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Canais de Contato <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control type="text" name="canais_contato" value={this.state.canais_contato} onChange={this.handleChange} />
                                                <Form.Text id="formCanaisContatoHelpBlock" className="text-danger">{this.state.canaisContatoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome da Equipe <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control type="text" name="nome_equipe" value={this.state.nome_equipe} onChange={this.handleChange} />
                                                <Form.Text id="formNomeEquipeHelpBlock" className="text-danger">{this.state.nomeEquipeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Template atendimento receptivo</Form.Label>
                                                <Form.Control type="text" name="template_atendimento_receptivo" value={this.state.template_atendimento_receptivo} onChange={this.handleChange} />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Link Política do Programa</Form.Label>
                                                <Form.Control type="text" name="link_politica_programa" value={this.state.link_politica_programa} onChange={this.handleChange} />
                                                <Form.Text id="formPoliticaProgramaHelpBlock" className="text-danger">{this.state.politicaProgramaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Link Regulamento do Programa</Form.Label>
                                                <Form.Control type="text" name="link_regulamento_programa" value={this.state.link_regulamento_programa} onChange={this.handleChange} />
                                                <Form.Text id="formRegulamentoProgramaHelpBlock" className="text-danger">{this.state.regulamentoProgramaHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>                                        
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Orientação Cadastro Médico <span style={{ color: 'red' }}> *</span></Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    name="orientacao_cadastro"
                                                    value={this.state.orientacao_cadastro} 
                                                    onChange={this.handleChange} 
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Instruções Termo Paciente</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    name="instrucoes_paciente_termo"
                                                    value={this.state.instrucoes_paciente_termo} 
                                                    onChange={this.handleChange} 
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Instruções 2 Termo Paciente</Form.Label>
                                                <Form.Control 
                                                    as="textarea"  
                                                    name="instrucoes2_paciente_termo"
                                                    value={this.state.instrucoes2_paciente_termo} 
                                                    onChange={this.handleChange} 
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Texto para sessão de dicas</Form.Label>
                                                <Form.Control 
                                                    as="textarea"  
                                                    name="dicas_texto"
                                                    value={this.state.dicas_texto} 
                                                    onChange={this.handleChange} 
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Informações de Atendimento</Form.Label>
                                                <Form.Control 
                                                    as="textarea"  
                                                    name="instrucao_atendimento"
                                                    value={this.state.instrucao_atendimento} 
                                                    onChange={this.handleChange} 
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Informações de Atendimento receptivo</Form.Label>
                                                <Form.Control 
                                                    as="textarea"  
                                                    name="informacoes_receptivo"
                                                    value={this.state.informacoes_receptivo} 
                                                    onChange={this.handleChange} 
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <h4 className="mt-3">Importação de Médicos</h4>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Modelo de Mensagem para Importação de Novo Médico:</Form.Label>
                                                <AsyncSelect
                                                    key={this.state.focusModeloNovo}
                                                    loadOptions={(inputValue) => {
                                                        return new Promise((resolve) => {
                                                            clearTimeout(this.modeloNovoSearchTimeout);
                                                            this.modeloNovoSearchTimeout = setTimeout(() => {
                                                                resolve(this.carregarModelosMensagem(inputValue, 'novo'));
                                                            }, 700);
                                                        });
                                                    }}
                                                    onFocus={() => {
                                                        this.setState({
                                                            focusModeloNovo: true
                                                        });
                                                    }}
                                                    autoFocus={this.state.focusModeloNovo}
                                                    openMenuOnFocus={this.state.focusModeloNovo}
                                                    defaultOptions
                                                    name="medico_novo_modelo_mensagem_id"
                                                    noOptionsMessage={() => "Nenhum modelo de mensagem encontrado"}
                                                    onChange={this.onChangeModeloNovo}
                                                    value={this.state.medico_novo_modelo_mensagem_id ? { value: this.state.medico_novo_modelo_mensagem_id, label: this.state.medico_novo_modelo_mensagem_titulo } : null}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Modelo de Mensagem para Importação de Médico Existente:</Form.Label>
                                                <AsyncSelect
                                                    key={this.state.focusModeloExistente}
                                                    loadOptions={(inputValue) => {
                                                        return new Promise((resolve) => {
                                                            clearTimeout(this.modeloExistenteSearchTimeout);
                                                            this.modeloExistenteSearchTimeout = setTimeout(() => {
                                                                resolve(this.carregarModelosMensagem(inputValue, 'existente'));
                                                            }, 700);
                                                        });
                                                    }}
                                                    onFocus={() => {
                                                        this.setState({
                                                            focusModeloExistente: true
                                                        });
                                                    }}
                                                    autoFocus={this.state.focusModeloExistente}
                                                    openMenuOnFocus={this.state.focusModeloExistente}
                                                    defaultOptions
                                                    name="medico_existente_modelo_mensagem_id"
                                                    noOptionsMessage={() => "Nenhum modelo de mensagem encontrado"}
                                                    onChange={this.onChangeModeloExistente}
                                                    value={this.state.medico_existente_modelo_mensagem_id ? { value: this.state.medico_existente_modelo_mensagem_id, label: this.state.medico_existente_modelo_mensagem_titulo } : null}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>                
                            </Card>
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Row>
                                        <h4 className="mt-3">Optout do Programa</h4>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Habilitar Optout</Form.Label>
                                                <div>
                                                    <Button 
                                                        variant={this.state.optout_habilitado ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ optout_habilitado: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button 
                                                        variant={!this.state.optout_habilitado ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ optout_habilitado: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {this.state.optout_habilitado == true && (
                                        <Row>
                                            <Col sm={4} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Título da Página</Form.Label>
                                                    <Form.Control type="text" name="optout_titulo" required placeholder="Título da Página" value={this.state.optout_titulo} onChange={this.handleChange} />
                                                    <Form.Text id="formLabelTituloHelpBlock" className="text-danger">{this.state.tituloHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Logomarca 1</Form.Label>
                                                    <Form.Control type="file" name="optout_logomarca_1" onChange={this.onChangeLogomarca1} ref={this.fileInput} />
                                                    <Form.Text id="formImagemBrancaHelpBlock" className="text-danger">{this.state.logomarca1Helper}</Form.Text>
                                                    {this.state.optout_logomarca_1 && (
                                                        <div>
                                                            <img src={this.state.optout_logomarca_1} alt="Imagem Atual" style={{ maxWidth: '100px', marginTop: '10px' }} />
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Logomarca 2</Form.Label>
                                                    <Form.Control type="file" name="optout_logomarca_2" onChange={this.onChangeLogomarca2} ref={this.fileInput} />
                                                    <Form.Text id="formImagemBrancaHelpBlock" className="text-danger">{this.state.logomarca2Helper}</Form.Text>
                                                    {this.state.optout_logomarca_2 && (
                                                        <div>
                                                            <img src={this.state.optout_logomarca_2} alt="Imagem Atual" style={{ maxWidth: '100px', marginTop: '10px' }} />
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col sm={4} xs={12}>
                                                <Form.Group className="row-list">
                                                    <Form.Label>Status ao realizar optout</Form.Label>
                                                    <Form.Control as="select" value={this.state.optout_status_id} name="optout_status_id" required onChange={this.handleChange}>
                                                        <option value="">Selecione um status</option>
                                                        {this.state.dados_status.map(status => (
                                                            <option key={status.slug} value={status.id}>{status.nome}</option>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Texto da Página</Form.Label>
                                                    <Form.Control 
                                                        as="textarea"  
                                                        name="optout_texto"
                                                        value={this.state.optout_texto} 
                                                        onChange={this.handleChange} 
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row> 
                                    )}

                                    {this.state.erroLoadCli ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadCli}
                                    </Alert> : ''
                                    }                                      
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar Dados do Programa
                                            </>
                                        )}
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Form> 
                        ) : (
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Row>
                                        <Col xs={12} style={{textAlign: "center"}}>
                                            <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                        </Col>    
                                    </Row>    
                                </Card.Body>
                            </Card>
                        )}
                    </Tab>
                    
                    {this.state.programa_id && (
                        <Tab eventKey="servicosDoPrograma" title="Serviços/Procedimentos">
                            {!this.state.loading && this.state.carregaServicosPrograma ? (
                                <ServicosProcedimentos programa_id={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.programa_id && (
                        <Tab eventKey="testeDoPrograma" title="Teste">
                            {!this.state.loading && this.state.carregaTestePrograma ? (
                                <MotivosOptout programa_id={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.programa_id && (
                        <Tab eventKey="etapasDoPrograma" title="Etapas">
                            {!this.state.loading && this.state.carregaEtapasPrograma && this.state.statusProgramaCarregado ? (
                                <EtapasPrograma programa_id={this.state.programa_id} status_programa={this.state.status_programa} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.programa_id && (
                        <Tab eventKey="produtosDoPrograma" title="Produtos">
                            {!this.state.loading && this.state.carregaProdutosPrograma ? (
                                <ProdutosPrograma programa_id={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && (
                        <Tab eventKey="botoesDoPrograma" title="Botões Atendimento">
                            {!this.state.loading && this.state.carregaBotoesAtendimento ? (
                                <BotoesAtendimento programa_id={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && (
                        <Tab eventKey="colunasDoPrograma" title="Colunas Atendimento">
                            {!this.state.loading && this.state.carregaColunasAtendimentoPrograma ? (
                                <ColunasAtendimento programa_id={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && (
                        <Tab eventKey="filtrosDoPrograma" title="Filtros Atendimento">
                            {!this.state.loading && this.state.carregaFiltrosAtendimentoPrograma ? (
                                <FiltrosAtendimento programa_id={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && (
                        <Tab eventKey="dicasDoPrograma" title="Dicas">
                           {!this.state.loading && this.state.carregaDicasPrograma ? (
                                <DicasPrograma programa_id={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}

                    {this.state.programa_id && (
                        <Tab eventKey="GraficosPrograma" title="Gráficos">
                           {!this.state.loading && this.state.carregaGraficosPrograma ? (
                                <GraficosPrograma programa_id={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.programa_id && (
                        <Tab eventKey="apiKeysPrograma" title="API Key">
                            {!this.state.loading && this.state.carregaApiKeysPrograma ? (
                                <ApiKeysPrograma programa_id={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.programa_id && (
                        <Tab eventKey="statusDoPrograma" title="Status do Programa">
                           {!this.state.loading && this.state.carregaStatusPrograma ? (
                                <StatusDoPrograma programa_id={this.state.programa_id} onStatusChange={this.handleStatusChange} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.programa_id && this.state.habilitar_gestao_aplicacoes && (
                        <Tab eventKey="monitoriaDoPrograma" title="Monitoria">
                            {this.state.habilitar_gestao_aplicacoes && !this.state.loading && this.state.carregaMonitoriaPrograma && this.state.dadosMonitoriaPrograma ? (
                                <MonitoriaPrograma programa_id={this.state.programa_id} dadosMonitoriaPrograma={this.state.dadosMonitoriaPrograma} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.programa_id && (
                        <Tab eventKey="doencasDoPrograma" title="Doenças do Programa">
                            {!this.state.loading && this.state.carregaDoencasPrograma && this.state.dadosDoencaPrincipal ? (
                                <DoencasPrograma programa_id={this.state.programa_id} dadosDoencaPrincipal={this.state.dadosDoencaPrincipal} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    
                    {this.state.programa_id && (
                        <Tab eventKey="FarmacovigilanciaPrograma" title="Farmacovigilância">
                            {!this.state.loading && this.state.carregaFarmacovigilanciaPrograma && this.state.dadosFarmacovigilancia ? (
                                <FarmacovigilanciaPrograma programa_id={this.state.programa_id} dadosFarmacovigilancia={this.state.dadosFarmacovigilancia} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.programa_id && this.state.optout_habilitado == true &&  ( 
                        <Tab eventKey="MotivosOptoutPrograma" title="Motivos Optout">
                            {!this.state.loading && this.state.carregaMotivosOptoutPrograma ? (
                                <MotivosOptout programa_id={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                    {this.state.programa_id && ( 
                        <Tab eventKey="AcoesPrograma" title="Ações Programa">
                            {!this.state.loading && this.state.carregaAcoesPrograma ? (
                                <AcoesPrograma programa_id={this.state.programa_id} />
                            ) : (
                                <Card className="cardDestaque">
                                    <Card.Body>                    
                                        <Row>
                                            <Col xs={12} style={{textAlign: "center"}}>
                                                <FaSpinner className="spinner-rotate" /><h4>Buscando dados...</h4>
                                            </Col>    
                                        </Row>    
                                    </Card.Body>
                                </Card>
                            )}
                        </Tab>
                    )}
                </Tabs>
            </div>
        )
    }
}

export default withRouter(ProgramasV2Edit);
